import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';

import { toAbsoluteUrl } from '../..';
import HeaderDropdownToggle from '../content/CustomDropdowns/HeaderDropdownToggle';
import { IAppState } from '../../../app/store/rootDuck';

const useStyles = makeStyles(theme => ({
  headerBtn: {
    marginLeft: theme.spacing(1),
  },
  authText: {
    display: 'none',

    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  cartText: {
    display: 'none',
    color: '#000',

    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  cartLoc: {
    marginRight: 20,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  cartBtn: {
    marginRight: 0,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  chatBtn: {
    marginRight: 10,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      marginRight: 20,
    },
  },
  cartBtnGuest: {
    marginRight: 30,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      marginRight: 30,
    },
  },
  cartBadge: {
    display: 'block',
    position: 'absolute',
    right: 0,
    width: 10,
    height: 10,
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      right: 0,
      transform: 'translateX(110%)',
    },
  },
  checkedOnLocation: {
    display: 'block',
    position: 'absolute',
    right: 10,
    width: 10,
    height: 10,
    [theme.breakpoints.up('md')]: {
      right: 5,
      transform: 'translateX(110%)',
    },
    [theme.breakpoints.down(920)]: {
      right: -15,
    },
  },
  notCheckedOnLocation: {
    position: 'absolute',
    right: -17,
    border: '1.5px solid ##DC1F1F',
    width: 25,
    height: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  auth: {
    marginLeft: '20px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
    },
  },
  profileAvatar: {
    width: 25,
    marginLeft: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
      width: 80,
    },
  },
  showAvatar: {
    objectFit: 'cover',
    width: 25,
    height: 25,
    borderRadius: '50%',
    borderColor: '#000',
    borderWidth: 2,
    borderStyle: 'solid',
  },
  notAvatar: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
    maxHeight: 25,
    cursor: 'pointer',
  },
  autoLoc: {
    width: '100%',
  },
  locationAlertContainer: {
    top: -130,
    right: -30,
    padding: 15,
    borderRadius: 0,
    width: 400,
    transform: 'initial',
    [theme.breakpoints.down(600)]: {
      width: '250px',
    },
    [theme.breakpoints.down(440)]: {
      right: -100,
    },
  },
  confirmButton: {
    color: '#293B85',
    border: '1px solid #293B85 !important',
  },
}));
type TProps = {
  showAvatar?: boolean;
};

const UserProfile: React.FC<TProps> = ({ showAvatar }) => {
  const intl = useIntl();
  const classes = useStyles();

  const { isAuthorized, me, loading, user } = useSelector((store: IAppState) => ({
    isAuthorized: store.auth.user != null,
    me: store.profile.me,
    loading: store.profile.loading,
    user: store.auth.user,
  }));

  if (loading) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {isAuthorized ? (
        <Dropdown
          className='kt-header__topbar-item kt-header__topbar-item--user'
          drop='down'
          alignRight
        >
          <Dropdown.Toggle as={HeaderDropdownToggle} id='dropdown-toggle-user-profile'>
            <div className='kt-header__topbar-user' style={{ cursor: 'pointer' }}>
              {showAvatar && (
                <div
                  style={{ background: '#FFFFFF', borderRadius: 16, width: 60, height: 60 }}
                  className={`kt-user-card__avatar ${classes.profileAvatar}`}
                >
                  <img
                    alt='Select file'
                    className={`kt-menu__link-icon  kt-menu-cart-icon ${classes.notAvatar}`}
                    style={{ maxHeight: 25 }}
                    src={toAbsoluteUrl('/media/icons/user.svg')}
                  />
                </div>
              )}
              <span
                style={{ fontSize: 16, fontWeight: 500 }}
                className='kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-primary'
              >
                {user?.user?.firstName || ''}
              </span>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className='dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl'>
            {/** ClassName should be 'dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
            <div
              className='kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x'
              style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/misc/bg-prof.jpg')})`,
                height: 78,
              }}
            >
              <div className='kt-user-card__name' style={{ fontWeight: 'bold' }}>
                {user?.user?.firstName || ''}
              </div>
            </div>
            <div className='kt-notification'>
              <div className='kt-notification__custom'>
                <Link
                  to='/logout'
                  className='btn btn-label-brand btn-sm'
                  style={{ fontSize: 14, textTransform: 'uppercase', fontWeight: 'normal' }}
                >
                  {intl.formatMessage({ id: 'SUBMENU.EXIT' })}
                </Link>
              </div>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Link to='/auth' className={`kt-login__signup ${classes.auth}`}>
          <img
            alt='Select file'
            style={{ maxHeight: 25 }}
            className={`kt-menu__link-icon  kt-menu-cart-icon`}
            src={toAbsoluteUrl('/images/profile-circle-auth1.svg')}
          />
          <div
            className={`kt-menu__link-text  ${classes.cartText}`}
            style={{ fontWeight: 700, color: '#DC1F1F' }}
          >
            <FormattedMessage id='SUBMENU.AUTHORIZE' defaultMessage={'SUBMENU.AUTHORIZE'} />
          </div>
        </Link>
      )}
    </div>
  );
};

export default UserProfile;
